/**
 * Product wordmark. Italic Bodoni for "ADS", roman for "Desk".
 */

import { cn } from "@/lib/utils";

export function BrandMark({
  size = "sm",
  className,
}: {
  size?: "sm" | "lg";
  className?: string;
}) {
  return (
    <span className={cn("ads-wordmark", size === "lg" && "ads-wordmark-lg", className)} aria-label="ADS Desk">
      <span className="ads-wordmark-ads">ADS</span>
      <span className="ads-wordmark-sep" aria-hidden>
        ·
      </span>
      <span className="ads-wordmark-desk">Desk</span>
    </span>
  );
}
